import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { ActionHandlerType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

// Web twin for `useMobileUtils.native.ts`. Deleting this breaks the web build: Next would
// resolve the .native file and pull expo-image into the web bundle.
function useMobileUtils() {
  const onMobileUtils: ActionHandlerType = useEventCallback(() => {
    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  });

  return { onMobileUtils };
}

export default useMobileUtils;
